import { useRef, useState } from 'react';

import { useCategoricalMouseEventHandlers } from './hooks/useCategoricalMouseEventHandlers.js';
import { CategoricalBarChartInspectOverlay } from './overlays/CategoricalBarChartInspectOverlay.js';
import { CategoricalBarChartOverlayRefContext } from '../../contexts/CategoricalBarChartOverlayRefContext.js';
import { CategoricalBarChartToolbar } from '../toolbar/CategoricalBarChartToolbar.js';

export const CategoricalBarChartOverlays = () => {
  const [shouldShowInspect, setShouldShowInspect] = useState(true);
  const overlayRef = useRef<HTMLDivElement>(null);
  const {
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
    handleFocus,
    handleBlur,
  } = useCategoricalMouseEventHandlers();

  const handleToolbarMouseEnter = () => {
    setShouldShowInspect(false);
  };

  const handleToolbarMouseLeave = () => {
    setShouldShowInspect(true);
  };

  return (
    <div
      tabIndex={0}
      ref={overlayRef}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{ height: '100%' }}
    >
      <CategoricalBarChartOverlayRefContext.Provider value={overlayRef}>
        {shouldShowInspect && <CategoricalBarChartInspectOverlay />}
        <CategoricalBarChartToolbar
          onMouseEnter={handleToolbarMouseEnter}
          onMouseLeave={handleToolbarMouseLeave}
        />
      </CategoricalBarChartOverlayRefContext.Provider>
    </div>
  );
};

CategoricalBarChartOverlays['displayName'] = 'CategoricalBarChartInteractions';
